import axios from 'axios';
import Api from './Api';

const { CancelToken } = axios;

let cancelRead;
class GlassHistoryApi extends Api {
  constructor() {
    super('glasses/histories', 'glasses/histories');
  }

  async readData(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    });
    return res;
  }
}
const glassHistoryApi = new GlassHistoryApi();

export default glassHistoryApi;
